/**
 * Shared JobTread status vocabulary and classification.
 *
 * JobTread job "status" text is org-configurable, so these heuristic lists are
 * the single source of truth for how the portal classifies a job. Previously
 * they were duplicated (with drift) across jobtreadService, useSalesDashboard,
 * useMarketingDashboard, and CloseRatio.
 */

export const CLOSED_JOB_STATUSES = ['closed', 'complete', 'completed', 'won', 'done', 'finished', 'sold'];

export const ACTIVE_JOB_STATUSES = ['active', 'in progress', 'inprogress', 'construction', 'production', 'open', 'current', 'started'];

export const PROPOSAL_JOB_STATUSES = ['proposal', 'estimate', 'pending', 'bid', 'quoted'];

export const PROPOSAL_DOC_TYPES = ['proposal', 'estimate', 'quote', 'bid'];

/** Used when a proposal has no probability from JobTread. */
export const DEFAULT_PROPOSAL_PROBABILITY = 0.5;

const matches = (status, list) => {
  const s = (status || '').toLowerCase();
  return !!s && list.some((entry) => s.includes(entry));
};

/**
 * Classify a raw JobTread status string.
 * @returns {'closed'|'active'|'proposal'|'other'}
 */
export const classifyJobStatus = (status) => {
  if (matches(status, CLOSED_JOB_STATUSES)) return 'closed';
  if (matches(status, PROPOSAL_JOB_STATUSES)) return 'proposal';
  if (matches(status, ACTIVE_JOB_STATUSES)) return 'active';
  return 'other';
};

export const isClosedStatus = (status) => classifyJobStatus(status) === 'closed';

export const isActiveStatus = (status) => classifyJobStatus(status) === 'active';

export const isProposalStatus = (status) => classifyJobStatus(status) === 'proposal';
